import { render, staticRenderFns } from "./JudgingCriteriaQuestionsList.vue?vue&type=template&id=3e408e9a&scoped=true"
import script from "./JudgingCriteriaQuestionsList.vue?vue&type=script&lang=js"
export * from "./JudgingCriteriaQuestionsList.vue?vue&type=script&lang=js"
import style0 from "./JudgingCriteriaQuestionsList.vue?vue&type=style&index=0&id=3e408e9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e408e9a",
  null
  
)

export default component.exports